import { useState } from "react";
import NeutralDocumentUploadComponent from "../../../../Components/DocumentUploader";
import {
  FormInput,
  FormSelect,
  FormTextArea,
} from "../../../../Components/Forms/InputTemplate";

export const FormContent = ({
  objIndex,
  kraIndex,
  defaultValues,
  formMethods,
  items,
}) => {
  const [documents, setDocuments] = useState([]);
  const handleDocumentsChange = (newDocuments) => {
    setDocuments(newDocuments);
    formMethods.setValue(
      `KRAs_${objIndex}_${kraIndex}_artifacts`,
      newDocuments
    );
  }; 
  const hasDocuments = documents?.length > 0; 
  return (
    <div className="px-5 w-full overflow-hidden">
      <FormInput
        title={"KRA Actual Score"}
        camelCase={`KRAs_${objIndex}_${kraIndex}_actualScore`}
        placeholder={"Enter actual score"}
        className="mb-4"
        type="number"
        isRequired={true}
        defaultValue={defaultValues?.kraActualScore}
      />
      <FormTextArea
        className="h-[100px]"
        title={"KRA Comments"}
        camelCase={`KRAs_${objIndex}_${kraIndex}_comments`}
        placeholder="Enter comments for this KRA"
        type="text" 
        textAreaClassName=""
        defaultValue={defaultValues?.comment}
      />
      <NeutralDocumentUploadComponent
        name={"Supporting Document"} defaultDocuments={defaultValues?.documents}
        title={"Upload Supporting Documents for KRA 500kb (pdf, jpg, docx)"}
        hasDocuments={hasDocuments}
        onDocumentsChange={handleDocumentsChange}
        id={`supportingDocuments_${objIndex}_${kraIndex}`}
      />
    </div>
  );
};
